/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Code_PlaceholderInputs */

const en_team_share_code_placeholder = /** @type {(inputs: Team_Share_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share Code`)
};

const fr_team_share_code_placeholder = /** @type {(inputs: Team_Share_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code de partage`)
};

const de_team_share_code_placeholder = /** @type {(inputs: Team_Share_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code teilen`)
};

const it_team_share_code_placeholder = /** @type {(inputs: Team_Share_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi il codice`)
};

const ru_team_share_code_placeholder = /** @type {(inputs: Team_Share_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код доступа`)
};

const es_team_share_code_placeholder = /** @type {(inputs: Team_Share_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código para compartir`)
};

const zh_cn2_team_share_code_placeholder = /** @type {(inputs: Team_Share_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享代码`)
};

const ja_team_share_code_placeholder = /** @type {(inputs: Team_Share_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードを共有`)
};

const hi_team_share_code_placeholder = /** @type {(inputs: Team_Share_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोड साझा करें`)
};

const pt_pt2_team_share_code_placeholder = /** @type {(inputs: Team_Share_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar código`)
};

/**
* | output |
* | --- |
* | "Share Code" |
*
* @param {Team_Share_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_code_placeholder = /** @type {((inputs?: Team_Share_Code_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Code_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_code_placeholder(inputs)
	if (locale === "de") return de_team_share_code_placeholder(inputs)
	if (locale === "it") return it_team_share_code_placeholder(inputs)
	if (locale === "ru") return ru_team_share_code_placeholder(inputs)
	if (locale === "es") return es_team_share_code_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_code_placeholder(inputs)
	if (locale === "ja") return ja_team_share_code_placeholder(inputs)
	if (locale === "hi") return hi_team_share_code_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_code_placeholder(inputs)
	return en_team_share_code_placeholder(inputs)
});